import { useState, useEffect } from "react"

import { useAuth } from "lib/auth"
import { useCart } from "lib/cart"
import { useTranslation } from "lib/i18n/translation"
import { useProducts } from "lib/products"
import { useCountry } from "lib/country"
import { useAccesses } from "lib/accesses"

const BundleAccessLink = ({ bundle, available, forceAvailable }) => {
	const { addToCart } = useCart()
	const { user } = useAuth()
	const { c } = useTranslation("common")
	const { purchasable, originalCountry, showAnotherCountry } = useCountry()
	const { isAvailable } = useProducts()
	const { hasAccessToAllProductsInBundle } = useAccesses()

	const availableBundle = available || isAvailable(bundle) || forceAvailable

	const [canBuyBundle, setCanBuyBundle] = useState(null)

	const manageAddToCart = () => {
		if (!originalCountry) {
			showAnotherCountry()
		} else {
			addToCart(bundle)
		}
	}

	useEffect(() => {
		const checkAccessToBundle = async () => {
			const hasTheAccesses = await hasAccessToAllProductsInBundle(bundle)

			if (!hasTheAccesses && purchasable && availableBundle) {
				setCanBuyBundle(true)

				return
			}

			setCanBuyBundle(false)
		}

		checkAccessToBundle()
	}, [user])

	if (!canBuyBundle) {
		return null
	}

	return (
		<p>
			<a
				href="#"
				onClick={e => {
					e.preventDefault();
					manageAddToCart()
				}}
				rel="nofollow noopener"
				title={c("add-to-cart")}
				data-overlay={"#overlay-add-pack-to-cart"}
				className="button icon-cart"
			>
				{c("watch-the-pack")}
			</a>
		</p>
	)
}

export default BundleAccessLink
